/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Apartment Unit
 */
export interface UnitDto { 
    budId?: number;
    cisloJednotky?: string;
    endDate?: string;
    id?: number;
    jedId?: number;
    katuzeKod?: number;
    katuzeNazev?: string;
    lv?: number;
    podilCitatel?: number;
    podilJmenovatel?: number;
    popis?: string;
    startDate?: string;
    typjedKod?: number;
    typjedNazev?: string;
    zpvyjeKod?: number;
    zpvyjeNazev?: string;
}

